<template>
    <div class="chkdDetails">
        <Detail ref="detail">
            <h2>{{ data.ti }}</h2>
            <div>
                <p><span>作者:</span> {{ data.au }}</p>
                <p><span>作者单位:</span> {{ data.affs }}</p>
                <p><span>领域:</span> {{ data.catalog }}</p>
                <p><span>关键词:</span> {{ data.kw }}</p>
                <p style="border-bottom:1px dashed;padding-bottom:0.5rem;margin-bottom:1rem;">
                    <span style="width:2.3rem">摘要:</span>
                    {{ data.ab }}
                </p>
            </div>
        </Detail>
        <!-- <van-popup v-model="codeShow">
            <img src="../../publics/image/ckbj.png" alt="" />
            <div>
                <van-field v-model="text" placeholder="请输入右侧验证码" />
                <img :src="imgUrl" alt="" @click="refreshCode" />
                <van-button color="#0d60a2" @click="downloadPdfContinue">
                    确认
                </van-button>
            </div>
        </van-popup> -->

        <Verify ref="verify" :captcha-type="captchaType"  />
        <!-- @success="login"   :img-size="{ width: '100%', height: '160px' }"-->
    </div>
</template>
<script>
// import api from "@/request/api/wpApi";
import Detail from "@/components/detail.vue";
import Verify from "@/components/verifition/Verify";

import wx from "weixin-js-sdk";
// import { Toast } from "vant";
// import Clipboard from "clipboard";

export default {
    data() {
        return {
            data: {},
            downY: "",
            imgUrl: "",
            codeShow: false,
            text: "",
            captchaType:''
        };
    },
    components: {
        Detail,
        Verify
    },
    mounted() {
        this.$store.dispatch("actionsHead", { type: true, title: "中国医院知识总库(CHKD)", iconType: true });
        this.$refs.detail.type = "chkd";
        var data = { url: decodeURIComponent(this.$route.query.url.split("?token")[0]) };
        this.$get("chkd/detail", data).then((response) => {
            sessionStorage.setItem("copyType", 0);
            if (/(Android)/i.test(navigator.userAgent)) {
                this.$refs.detail.copyShow = false;
                this.$refs.detail.pdfLink = "";
            }
            if (response.data.downloadUrl != "" && response.data.downloadUrl != null) {
                this.$refs.detail.downloadData = { url: decodeURIComponent(response.data.downloadUrl) };
                this.$refs.detail.pdfShow = true;
            } else {
                this.$refs.detail.pdfShow = false;
            }
            this.data = response.data;
        });
    },
    methods: {
        refresh() {
            // this.refreshCode();
            // this.codeShow = true;
            this.$refs.verify.show()
            this.captchaType = 'blockPuzzle'
        },
        // refreshCode() {
        //     this.$get("chkd/refreshCode", {}).then((response) => {
        //         var res = JSON.parse(response.data)

        //         this.imgUrl = res.repData.originalImageBase64;
        //     });
        // },
        downloadPdfContinue() {
            if (this.downY !== "") {
                if (window.__wxjs_environment === "miniprogram") {
                    if (this.downY != "" && this.downY != null && this.downY != undefined) {
                        wx.miniProgram.navigateTo({
                            url: "../a/a?pdfUrl=" + this.downY
                        });
                    }
                } else {
                    window.location.href = this.downY;
                }
            } else {
                this.$get("chkd/downloadContinue", { code: this.text }).then((response) => {
                    if (response.code == 0) {
                        this.downY = response.data;
                        this.codeShow = false;

                        this.$refs.detail.copyShow = true;
                        this.$refs.detail.pdfLink = response.data;
                        var isWX = window.__wxjs_environment === "miniprogram";
                        if (isWX) {
                            if (response.data != "" && response.data != null && response.data != undefined) {
                                wx.miniProgram.navigateTo({
                                    url: "../a/a?pdfUrl=" + response.data
                                });
                            }
                        } else {
                            sessionStorage.setItem("copyType", 1);
                            sessionStorage.setItem("pdfLink", response.data);
                            window.location.href = response.data;
                        }
                    }
                });
            }
            this.show = false;
        }
    },
    beforeRouteLeave(to, from, next) {
        if (to.name === "chkdList" || to.name === "sDetail") {
            this.$destroy();
            sessionStorage.setItem("copyType", 0);
            next(); // 当我们前进的不是C时我们让B页面刷新
        }
    }
};
</script>
<style lang="less">
.chkdDetails {
    h2 {
        color: #0c60a3;
    }

    > p {
        color: #929292;
        padding-bottom: 1rem;
        border-bottom: 1px solid #f3f3f3;
    }

    div {
        p {
            margin-top: 0.5rem;
            line-height: 1.5rem;

            span {
                width: 26%;
                display: inline-block;
            }
        }

        button {
            background-color: rgb(13, 96, 162) !important;
            border-color: rgb(13, 96, 162) !important;
        }
    }
}
</style>
